import { render, staticRenderFns } from "./adjunto.vue?vue&type=template&id=79e2011e"
import script from "./adjunto.vue?vue&type=script&lang=js"
export * from "./adjunto.vue?vue&type=script&lang=js"
import style0 from "./adjunto.vue?vue&type=style&index=0&id=79e2011e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports